/**
 * Martin Saddlery — Shop Pay installments line
 * -------------------------------------------------------------------------
 * Shopify renders <shopify-payment-terms> in an open shadow root and pins its
 * text to Shopify's own font (.font-sans { font-family: GTStandard-M }).
 * Inject one rule so the text inherits the theme body font from the host
 * element (styled in custom-martin-product.css). The Shop logo keeps its
 * brand colour. Re-applied if Shopify re-renders the shadow root, e.g. on
 * variant change.
 */
(() => {
  const STYLE_ID = 'martin-payment-terms-font';
  const CSS = '.font-sans, #shopify-installments { font-family: inherit; }';

  const apply = (host) => {
    const root = host.shadowRoot;
    if (!root || root.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
  };

  const watch = (host) => {
    if (host.dataset.martinFontWatched) return;
    host.dataset.martinFontWatched = 'true';
    apply(host);
    if (host.shadowRoot) {
      new MutationObserver(() => apply(host)).observe(host.shadowRoot, { childList: true });
    }
  };

  const init = () => document.querySelectorAll('shopify-payment-terms').forEach(watch);

  customElements.whenDefined('shopify-payment-terms').then(() => {
    init();
    // Hosts can be re-created when the product section re-renders.
    new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
  });
})();
